import React from 'react';

import Alert from '@mui/material/Alert';
import NotificationsIcon from '@mui/icons-material/Notifications';

import { AlertTitle, Snackbar } from '@mui/material';

function CustomSnackbar(prop) {
  const { message, variant, open, setOpen } = prop;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const vertical = 'top';
  const horizontal = 'right';

  return (
    <Snackbar
      open={open}
      autoHideDuration={15000}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={handleClose}
        severity={variant === 'notification' ? 'info' : variant}
        sx={{ width: '100%' }}
        variant="filled"
        className={`${variant === 'notification' ? 'bg-black ' : ''}`}
        icon={variant === 'notification' ? <NotificationsIcon /> : null}
      >
        <AlertTitle>{variant.toUpperCase()}</AlertTitle>
        {typeof message === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          message
        )}
      </Alert>
    </Snackbar>
  );
}
export default CustomSnackbar;
// variant
// error
// warning
// info
// success
